import React, { Fragment } from 'react';
import compose from 'recompose/compose';
import Card from '@material-ui/core/Card';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { withStyles } from '@material-ui/core/styles';
import {
    translate,
    SimpleForm,
    DateInput,
    required,
    GET_ONE,
    crudCreate,
} from 'react-admin';
import { startUndoable as startUndoableAction } from 'ra-core';
import Button from '@material-ui/core/Button';
import SimpleButton from '@material-ui/core/Button';
import { connect } from 'react-redux';
import { submit } from 'redux-form';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import AddIcon from '../../icon/IcnOperateAdd';
import dataProvider from '../../dataProvider';
import SaveButton from '../common/SaveButton';
import {
    format,
    parseISO,
    endOfYesterday
} from 'date-fns'

const validateRange = (minDate, maxDate) => (value, allValues, props) => {
    var date = parseISO(value);
    if (date < minDate || date > maxDate)
        return props.translate('notification.invalidRequestParameter');
}

const style = theme => ({
    formControl: {
        minWidth: 250,
        marginRight: '5em',
        marginLeft: '5em',
        display: 'flex',
        flexWrap: 'wrap',
    },
    card: {
        marginTop: '2em',
    },
    button: { marginRight: '1em', marginLeft: '1em' },
});

class ReportCreateButton extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            showDialog: false,
            minReportDate: new Date(),
            maxReportDate: endOfYesterday(),
        };
    }

    componentDidMount() {
        dataProvider(GET_ONE, 'tenants', { id: 'me' })
            .then(response => response.data)
            .then(data => {
                this.setState({ minReportDate: parseISO(data.serviceStartDate) });
            });
    }

    handleClick = () => {
        this.setState({ showDialog: true });
    }

    handleSaveClick = () => {
        const { submit } = this.props;
        submit('create-report');
    }

    handleCloseClick = () => {
        this.setState({ showDialog: false });
    }

    handleSubmit = values => {
        const { resource, basePath, startUndoable } = this.props
        startUndoable(
            crudCreate(
                resource,
                { ...values },
                basePath,
                'list',
            )
        );
        this.setState({ showDialog: false });
    }

    render() {
        const { translate, classes } = this.props;
        return (
            <Fragment>
                <SimpleButton onClick={this.handleClick} color="primary" size="small">
                    <AddIcon />
                    {translate('resources.reports.fields.createReport')}
                </SimpleButton>
                <Dialog
                    fullWidth
                    open={this.state.showDialog}
                    onClose={this.handleCloseClick}
                >
                    <DialogContent>
                        <DialogContentText>
                            <p>
                                {translate('resources.reports.fields.createReportGuidance1')}
                            </p>
                            <ul>
                                <li>
                                    {translate('resources.reports.fields.createReportGuidance2')}
                                </li>
                                <li>
                                    {translate('resources.reports.fields.createReportGuidance3')}
                                    <br />
                                    {translate('resources.reports.fields.createReportGuidance4') + format(this.state.minReportDate, "yyyy/MM/dd") + " - " + format(this.state.maxReportDate, "yyyy/MM/dd")}
                                </li>
                            </ul>
                        </DialogContentText>
                        <SimpleForm toolbar={null} form='create-report' onSubmit={this.handleSubmit} submitOnEnter={false}>
                            <DateInput source="startDate" label='resources.reports.fields.startDate' validate={[required(), validateRange(this.state.minReportDate, this.state.maxReportDate)]} />
                            <DateInput source="endDate" label='resources.reports.fields.endDate' validate={[required(), validateRange(this.state.minReportDate, this.state.maxReportDate)]} />
                        </SimpleForm>
                    </DialogContent>
                    <DialogActions>
                        <SaveButton
                            label='resources.reports.fields.create'
                            onClick={this.handleSaveClick}
                        />
                        <SimpleButton
                            onClick={this.handleCloseClick}
                            color='primary'>
                            {translate('ra.action.cancel')}
                        </SimpleButton>
                    </DialogActions>
                </Dialog>
            </Fragment>
        );
    }
}

const enhance = compose(
    withStyles(style),
    translate,
    connect(
        undefined,
        { submit, startUndoable: startUndoableAction, crudCreate }
    ),
);

export default enhance(ReportCreateButton);